import { PulseRefreshResponseSchema, PulseSettingsResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type PulseSettingsResponseInput = z.input<typeof PulseSettingsResponseSchema>;
export type PulseSettingsResponseOutput = z.output<typeof PulseSettingsResponseSchema>;

export function serializePulseSettingsResponse(payload: PulseSettingsResponseInput): PulseSettingsResponseOutput {
  return PulseSettingsResponseSchema.parse(payload);
}

export type PulseRefreshResponseInput = z.input<typeof PulseRefreshResponseSchema>;
export type PulseRefreshResponseOutput = z.output<typeof PulseRefreshResponseSchema>;

export function serializePulseRefreshResponse(payload: PulseRefreshResponseInput): PulseRefreshResponseOutput {
  return PulseRefreshResponseSchema.parse(payload);
}
